export default __webpack_public_path__ + "static/media/(102).a96a5d24.jpg";